import { colorGroups as chartColorGroups } from '@unifyapps/defs/blocks/Chart/chartColorGroups';
import { backgroundColorGroups } from '@unifyapps/defs/constants/backgroundColorGroups';
import type { ColorGroups } from '../../../../components/ColorPicker';

const borderColors = [
  {
    id: 'border-transparent',
    value: 'transparent',
    label: 'Transparent',
  },
  {
    id: 'border-brand-solid',
    value: '--border-brand-solid',
    label: 'Brand Solid',
  },
  {
    // todo: check this case, where border-brand-solid would be duplicated
    id: 'border-brand-solid',
    value: '--border-brand-solid',
    label: 'Brand Solid Alt',
  },
  {
    id: 'border-primary',
    value: '--border-primary',
    label: 'Primary',
  },
  {
    id: 'border-secondary',
    value: '--border-secondary',
    label: 'Secondary',
  },
  {
    id: 'border-tertiary',
    value: '--border-tertiary',
    label: 'Tertiary',
  },
  {
    id: 'border-success',
    value: '--border-success',
    label: 'Success',
  },
  {
    id: 'border-warning',
    value: '--border-warning',
    label: 'Warning',
  },
  {
    id: 'border-error',
    value: '--border-error',
    label: 'Error',
  },
  {
    id: 'border-white',
    value: '--border-white',
    label: 'White',
  },
];

export const borderColorGroups: ColorGroups[] = [
  {
    id: 'borderColor',
    label: 'Border Colors',
    colors: borderColors,
  },
];

export const getColorGroupById = (id: string) => {
  switch (id) {
    case 'borderColor':
      return borderColorGroups;
    case 'backgroundColor':
      return backgroundColorGroups;
    case 'chartHoverColor':
    case 'chartActiveColor':
      return chartColorGroups;
    default:
      return [];
  }
};
